import { render } from "./CategoriesTable1.vue?vue&type=template&id=516a74fd&scoped=true"
import script from "./CategoriesTable1.vue?vue&type=script&lang=js"
export * from "./CategoriesTable1.vue?vue&type=script&lang=js"

import "./CategoriesTable1.vue?vue&type=style&index=0&id=516a74fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516a74fd"]])

export default __exports__